// // alert();
// let lastScrollY = window.scrollY;
//   window.addEventListener('scroll', () => {
//     const header = document.querySelector('header');
//     if (window.scrollY > lastScrollY) {
//       header.style.top = "-100px";
//     } else {

//       header.style.position = "sticky";
//       header.style.top = "0";
//     }
//     lastScrollY = window.scrollY;
//   });
document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll(".language-dropdown");
  dropdowns.forEach((dropdown) => {
    const toggleButton = dropdown.querySelector(".dropdown-toggle");
    const menu = dropdown.querySelector(".dropdown-menu");
    const options = menu.querySelectorAll("li");
    const select = dropdown.querySelector("select");
    toggleButton.addEventListener("click", () => {
      const expanded = toggleButton.getAttribute("aria-expanded") === "true";
      toggleButton.setAttribute("aria-expanded", !expanded);
      menu.style.display = expanded ? "none" : "block";
    });
    options.forEach((option) => {
      option.addEventListener("click", () => {
        const value = option.getAttribute("data-value");
        const label = option.textContent;
        toggleButton.textContent = label;
        options.forEach((opt) => opt.removeAttribute("aria-selected"));
        option.setAttribute("aria-selected", "true");
        select.value = value;
        const langCode = value;
        const currentPath = window.location.pathname;
        let newPath = "";
        if (langCode === "fr") {
          newPath = currentPath.replace(/^\/[a-z]{2}(\/|$)/, "/");
        } else {
          if (/^\/[a-z]{2}(\/|$)/.test(currentPath)) {
            newPath = currentPath.replace(
              /^\/[a-z]{2}(\/|$)/,
              "/" + langCode + "/"
            );
          } else {
            newPath = "/" + langCode + currentPath;
          }
        }
        const search = window.location.search;
        const hash = window.location.hash;
        const newUrl = newPath + search + hash;
        window.location.href = newUrl;

        toggleButton.setAttribute("aria-expanded", "false");
        menu.style.display = "none";
      });
    });
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target)) {
        toggleButton.setAttribute("aria-expanded", "false");
        menu.style.display = "none";
      }
    });
  });


});
function initializeSliders() {
  const sliders = document.querySelectorAll(".product-card__media-slider");
  sliders.forEach((slider) => {
    if (slider.classList.contains("slider-initialized")) return;
    slider.classList.add("slider-initialized");
    const slides = slider.querySelector(".product-card__media-slides");
    const prevBtn = slider.querySelector(".product-card__media-prev");
    const nextBtn = slider.querySelector(".product-card__media-next");
    const dots = slider.querySelectorAll(".product-card__media-dot");
    let currentIndex = 0;
    function updateSlider() {
      slides.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === currentIndex);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        currentIndex =
          (currentIndex - 1 + slides.children.length) % slides.children.length;
        updateSlider();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % slides.children.length;
        updateSlider();
      });
    }
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        currentIndex = index;
        updateSlider();
      });
    });
    updateSlider();
  });
}
document.addEventListener("DOMContentLoaded", initializeSliders);
document.addEventListener("shopify:section:load", initializeSliders);
document.addEventListener("shopify:section:reorder", initializeSliders);
document.addEventListener("shopify:section:select", initializeSliders);
document.addEventListener("shopify:section:deselect", initializeSliders);
document.addEventListener("shopify:block:select", initializeSliders);
document.addEventListener("shopify:block:deselect", initializeSliders);
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      initializeSliders();
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", () => {
  const colorSwatchLinks = document.querySelectorAll(
    ".main-product-color-swatch a"
  );
  colorSwatchLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const targetURL = link.getAttribute("href");
      window.location.href = targetURL;
    });
  });
});

// color swatch tooltip
// document.querySelectorAll('.tooltip').forEach(tooltipEl => {
//     const tooltipText = tooltipEl.querySelector('.tooltiptext');

//     tooltipEl.addEventListener('mouseenter', () => {
//       tooltipText.style.opacity = '1';
//     });

//     tooltipEl.addEventListener('mousemove', (e) => {
//       tooltipText.style.left = e.clientX + 15 + 'px';
//       tooltipText.style.top = e.clientY + 15 + 'px';
//     });

//     tooltipEl.addEventListener('mouseleave', () => {
//       tooltipText.style.opacity = '0';
//     });
//   });  
